import { lazy } from "react";
import { AuthenticatedHomeRedirect, AuthenticatedRedirect } from "./AuthRedirect";
import SuperAdminProtected from "./SuperAdminProtected";

// Authentication
const Login = lazy(() => import("../pages/Authentication/Login"));
const Logout = lazy(() => import("../pages/Authentication/Logout"));

// Admin pages
const AdminDashboard = lazy(() => import("../pages/Admin/Dashboard"));
const AdminProperties = lazy(() => import("../pages/Admin/Properties"));
const AdminPropertyReview = lazy(() => import("../pages/Admin/PropertyReview"));
const AdminPropertyEdit = lazy(() => import("../pages/Admin/PropertyEdit"));
const AdminPropertyAccess = lazy(() => import("../pages/Admin/PropertyAccess"));
const AdminVendors = lazy(() => import("../pages/Admin/Vendors"));
const AdminVendorDetails = lazy(() => import("../pages/Admin/VendorDetails"));
const AdminVendorGroups = lazy(() => import("../pages/Admin/VendorGroups"));
const AdminBookings = lazy(() => import("../pages/Admin/Bookings"));
const AdminPromotions = lazy(() => import("../pages/Admin/Promotions"));
const AdminReports = lazy(() => import("../pages/Admin/Reports"));
const AdminReportViewer = lazy(() => import("../pages/Admin/Reports/Viewer"));
const AdminPromotionCreate = lazy(() => import("../pages/Admin/Promotions/Create"));
const AdminPromotionEdit = lazy(() => import("../pages/Admin/Promotions/Edit"));

const authProtectedRoutes = [
  { path: "/dashboard", component: <AdminDashboard /> },
  { path: "/properties", component: <AdminProperties /> },
  { path: "/properties/:id", component: <AdminPropertyReview /> },
  { path: "/properties/:id/edit", component: <SuperAdminProtected><AdminPropertyEdit /></SuperAdminProtected> },
  { path: "/property-access", component: <AdminPropertyAccess /> },
  { path: "/vendors", component: <AdminVendors /> },
  { path: "/vendor-groups", component: <AdminVendorGroups /> },
  { path: "/vendors/:id", component: <AdminVendorDetails /> },
  { path: "/bookings", component: <AdminBookings /> },
  { path: "/reports", component: <AdminReports /> },
  { path: "/reports/:reportKey", component: <AdminReportViewer /> },
  { path: "/promotions", component: <SuperAdminProtected><AdminPromotions /></SuperAdminProtected> },
  { path: "/promotions/create", component: <SuperAdminProtected><AdminPromotionCreate /></SuperAdminProtected> },
  { path: "/promotions/:id", component: <SuperAdminProtected><AdminPromotionEdit /></SuperAdminProtected> },

  { path: "/index", component: <AuthenticatedHomeRedirect /> },
  { path: "/", exact: true, component: <AuthenticatedHomeRedirect /> },
  { path: "*", component: <AuthenticatedHomeRedirect /> },
];

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <AuthenticatedRedirect><Login /></AuthenticatedRedirect> },
];

export { authProtectedRoutes, publicRoutes };
